import React from 'react';
import { connect } from 'dva';
import Page from '../../../lib/page';
import { Link } from 'dva/router';
import { Row, Col } from 'antd';
import wandu from '../../../service/wandu';
import env from '../../../lib/env';
import LinesEllipsis from 'react-lines-ellipsis';
import styles from './index.css';

class BookrackPage extends Page {
	constructor(props){
		super(props)
		this.state={
			collect_log:[],
		}
	}

	componentDidMount() {		
        if (!this.props.user.user_id) {
           env.goto_page('/'); 
           return;
        }
        wandu.get_bookrack().then(res => {
            var collect_log = res.collect_log;
            this.setState({
				collect_log: collect_log,
			})           
        }).catch(e => {
            console.log(e);
        });
    }

    componentDidUpdate() {
        if (!this.props.user.user_id) {
           env.goto_page('/'); 
           return;
        }
    }

    render() {
        return (
		<div style={{width:'1000px',margin:'0 auto'}}>
			<div className={styles.user_info}>
				<img src={this.props.user.avatar} alt='' />
				<span>{this.props.user.name}</span>
			</div>
            <Row type='flex' justify="start">
            {this.state.collect_log.map((item, idx) => (
                <Col key={idx} className={styles.collect}>             
                    <Link to={`/book/read/${item.novel_id}`}>
                    <img src={item.pic ? item.pic : 'https://img.wandu.cn/novel/cover/2017-07-14/5B574F88BB6AC4AF795848FB782D9D5B.jpeg'} alt='' />
                    <div>
						<LinesEllipsis text={item.novel_name} maxLine={1} />
                    </div>
                    </Link>
                </Col>
            ))}
                <Col className={styles.collect}>
					<Link to='/category'>
					<img src='https://img.wandu.cn/novel/cover/2018-08-28/88FDF0C8F6A02788FD14457554EE2F26.png' alt='添加新书' />
					</Link>
                </Col>
            </Row>
		</div>
		);
    }
}

const state_props = state => {
    return {
        user: state.user, 
    }
}

export default connect(state_props)(BookrackPage);



// WEBPACK FOOTER //
// ./src/layout/user/bookrack/index.js